import { render, staticRenderFns } from "./InvoiceDiscountFormat.vue?vue&type=template&id=ba81c3c0&"
import script from "./InvoiceDiscountFormat.vue?vue&type=script&lang=js&"
export * from "./InvoiceDiscountFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports